// extracted by mini-css-extract-plugin
export default {"container_faq":"FAQ_container_faq__lgXkn","h1_faq":"FAQ_h1_faq__BE1XX","item_faq":"FAQ_item_faq__qVxQO"};